import {
  REGISTER_ARTIST,
  REGISTER_ARTIST_SUCCESSFUL,
  REGISTER_ARTIST_FAILED,
  FETCH_COUNTRIES,
  SET_COUNTRIES,
  USER_SUBSCRIBE,
  USER_SUBSCRIBE_FAILED,
  USER_SUBSCRIBE_SUCCESSFUL,
  GETTOP_ARTIST,
  GETTOP_ARTIST_FAILED,
  GETMYTOP_ARTIST_SUCCESSFUL,
  NEWSLETTER,
  NEWSLETTER_FAILED,
  NEWSLETTER_SUCCESSFUL,
} from "./actionTypes";

export const registerUser = (user, navigate) => {
  return {
    type: REGISTER_ARTIST,
    payload: { user, navigate },
  };
};

export const registerUserSuccessful = (user) => {
  return {
    type: REGISTER_ARTIST_SUCCESSFUL,
    payload: user,
  };
};

export const registerUserFailed = (error) => {
  return {
    type: REGISTER_ARTIST_FAILED,
    payload: { error },
  };
};
export const fetchCountries = () => ({
  type: FETCH_COUNTRIES,
});

export const setCountries = (countries) => ({
  type: SET_COUNTRIES,
  payload: countries,
});
export const userSubsCribe = (user, navigate) => {
  return {
    type: USER_SUBSCRIBE,
    payload: { user, navigate },
  };
};

export const userSubscribeSuccessful = (user) => {
  return {
    type: USER_SUBSCRIBE_SUCCESSFUL,
    payload: user,
  };
};

export const userSubscribeFail = (user) => {
  return {
    type: USER_SUBSCRIBE_FAILED,
    payload: user,
  };
};

//  New Letter

export const newsletter = (user, callback) => {
  return {
    type: NEWSLETTER,
    payload: { user, callback },
  };
};
export const newsletterFail = (user) => {
  return {
    type: NEWSLETTER_FAILED,
    payload: user,
  };
};

export const newsletterSuccessful = (user) => {
  return {
    type: NEWSLETTER_SUCCESSFUL,
    payload: user,
  };
};

//  GET top Artist

export const getTopArtist = (data, callback) => ({
  type: GETTOP_ARTIST,
  payload: { data, callback },
});

export const getTopArtistFail = (error) => ({
  type: GETTOP_ARTIST_FAILED,
  payload: error,
});

export const getmyTopArtistSuccess = (data) => ( {
  type: GETMYTOP_ARTIST_SUCCESSFUL,
  payload: data,
});
